import React, { useMemo } from 'react';
import { HierarchyColumnConfig } from 'common/visualizations/vif';
import {
  ForgeExpansionPanel,
  ForgeList,
  ForgeListItem,
  ForgeOpenIcon,
  ForgeTextField,
} from '@tylertech/forge-react';
import { I18n } from 'common/i18n';

interface SubtotalsSectionProps {
  columnGroups: HierarchyColumnConfig[];
  columnNames: string[];
}

const scope = 'shared.components.advanced_totaling.modal';

const SUBTOTAL_COL_START_INDEX = 1; // Skip the first column (main total)
const SUBTOTAL_COL_END_INDEX = 5; // Limit the columns to a maximum of 4 for subtotals

const SubtotalsSection: React.FC<SubtotalsSectionProps> = ({
  columnGroups,
  columnNames,
}: SubtotalsSectionProps) => {
  const subtotalColGroups = useMemo(() => {
    return columnGroups.slice(SUBTOTAL_COL_START_INDEX, SUBTOTAL_COL_END_INDEX);
  }, [columnGroups]);

  const subtotalColumnNames = useMemo(() => {
    return columnNames.slice(SUBTOTAL_COL_START_INDEX, SUBTOTAL_COL_END_INDEX);
  }, [columnNames]);

  return (
    <>
      {subtotalColGroups && !!subtotalColGroups.length && !!subtotalColumnNames.length && (
        <>
          <div>
            <span className="forge-typography--body2 group-category">{I18n.t('subtotals', { scope })}</span>
          </div>
          {subtotalColGroups.map((colGroup: HierarchyColumnConfig, index: number) => (
            <ForgeList key={colGroup.columnName} data-testid={'subtotals-row'}>
              <ForgeExpansionPanel>
                <ForgeListItem slot={'header'} className={'expansion-header'}>
                  <span className="forge-typography--body1">{subtotalColumnNames[index]}</span>
                  <ForgeOpenIcon slot={'trailing'}></ForgeOpenIcon>
                </ForgeListItem>
                <div>
                  <ForgeTextField>
                    <label className="forge-typography--label2">{I18n.t('enter_formula', { scope })}</label>
                    <textarea data-testid="subtotals-formula"></textarea>
                  </ForgeTextField>
                </div>
              </ForgeExpansionPanel>
            </ForgeList>
          ))}
        </>
      )}
    </>
  );
};

export default SubtotalsSection;
